
import { useState } from "react";
import { toast } from "sonner";
import { supabase } from "@/integrations/supabase/client";

export const useAIAnalysis = (onComplete: (data: { formattedText: string; voNumber: string | null }) => void) => {
  const [isAnalyzing, setIsAnalyzing] = useState(false);

  const analyzeText = async (message: string) => {
    if (!message?.trim()) {
      toast.error("Er is geen bericht om te analyseren");
      return;
    }

    setIsAnalyzing(true);
    toast.info("AI pakbon wordt gegenereerd...", { id: "ai-analysis" });

    console.log("Sending for AI analysis:", message);
    
    try {
      const { data, error } = await supabase.functions.invoke('analyze-notification', {
        body: { 
          message,
          customPrompt: null
        },
      });
      
      if (error) {
        console.error("Error in AI analysis:", error);
        throw error;
      }
      
      console.log("AI analysis result:", data);
      onComplete(data);
      
      toast.success("AI pakbon gegenereerd", { id: "ai-analysis" });
    } catch (error: any) {
      console.error("Error in AI analysis:", error);
      toast.error("Fout bij het genereren van AI pakbon: " + (error.message || "Onbekende fout"), 
        { id: "ai-analysis" });
    } finally {
      setIsAnalyzing(false);
    }
  };

  return {
    isAnalyzing,
    setIsAnalyzing,
    analyzeText
  };
};
